module.exports = __webpack_public_path__ + "AbhiA-530deeb7.webp";